var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"truncated-text"},[_c('p',[_vm._v(_vm._s(_vm.visibleText)),(_vm.hasExtra)?[_c('span',{staticClass:"reveal-text color-mr-purple underline clickable",class:{ 'as-block': !_vm.inline },domProps:{"innerHTML":_vm._s(_vm.controlText)},on:{"click":_vm.toggleText}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }